import usePageTracking from "../../utils/gtm-page-tracking";

const Contact = () => {
    usePageTracking();

    return (
        <section id="contact">
            <div className="container-fluid mb-5">
                <div className="row gg-bg-gradient-h align-items-center justify-content-center text-white py-5">
                    <div className="col-lg-8 text-center">
                        <h1 className="display-4 fw-bold">
                            Contact Us
                        </h1>
                    </div>
                </div>
                <div className="row align-items-center justify-content-center mt-4">
                    <div className="col-md-8 col-10 text-center">
                        <p>Do you have any questions?</p>
                        <p>Please do not hesitate to<br />
                        📞 call us at <a href="tel:+1 (302) 200-3480">+1 (302) 200-3480</a>.<br />
                        📩 send us an email at <a href="mailto:support@drhartlabs.com">support@drhartlabs.com</a></p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;